import { useEffect, useState } from "react";
import { Trophy, FileText, Briefcase, Flame, ShoppingBag } from "lucide-react";
import { api } from "@/lib/api";

const ICONS = { sale: ShoppingBag, cv: FileText, offer: Briefcase, client: Trophy, streak: Flame };

export const WinWall = () => {
  const [wins, setWins] = useState([]);
  useEffect(() => {
    api.get("/public/wins").then(({ data }) => setWins(data.wins || [])).catch(() => {});
  }, []);
  if (wins.length < 2) return null;
  const loop = [...wins, ...wins];
  return (
    <section className="mx-auto max-w-7xl overflow-hidden px-6 pb-16 md:px-10" data-testid="win-wall">
      <p className="text-center text-xs uppercase tracking-[0.25em] text-muted-foreground">Real wins, happening now</p>
      <div className="relative mt-6">
        <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-16 bg-gradient-to-r from-background to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-16 bg-gradient-to-l from-background to-transparent" />
        <div className="flex w-max animate-[winscroll_40s_linear_infinite] gap-3">
          {loop.map((w, i) => {
            const Icon = ICONS[w.icon] || Trophy;
            return (
              <div key={i} className="flex shrink-0 items-center gap-2.5 rounded-full border border-border bg-card px-4 py-2.5 text-sm"
                data-testid={i < wins.length ? `win-item-${i}` : undefined}>
                <Icon className="h-4 w-4 text-emerald-400" />
                <span className="whitespace-nowrap">{w.text}</span>
              </div>
            );
          })}
        </div>
      </div>
      <style>{`@keyframes winscroll { from { transform: translateX(0); } to { transform: translateX(-50%); } }`}</style>
    </section>
  );
};
